import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/pages/Home";
import TalentenspelBegeleiding from "@/components/pages/TalentenspelBegeleiding";
import Talentenspel from "@/components/pages/Talentenspel";
import Scholing from "@/components/pages/Scholing";
import PersoonlijkeSupervisie from "@/components/pages/PersoonlijkeSupervisie";
import ModuleCommunicatieCounseling from "@/components/pages/ModuleCommunicatieCounseling";
import Nascholing from "@/components/pages/Nascholing";
import Contact from "@/components/pages/Contact";
import ScholingTalentenspelCoaches from "@/components/pages/ScholingTalentenspelCoaches";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Home
    }
    // {
    // 	path: '/talentenspel-begeleiding',
    // 	component: TalentenspelBegeleiding
    // },
    // {
    // 	path: '/talentenspel',
    // 	component: Talentenspel
    // },
    // {
    // 	path: '/scholing/persoonlijke-supervisie',
    // 	component: PersoonlijkeSupervisie
    // },
    // {
    // 	path: '/scholing/module-communicatie-counseling',
    // 	component: ModuleCommunicatieCounseling
    // },
    // {
    // 	path: '/scholing',
    // 	component: Scholing
    // },
    // {
    // 	path: '/scholing/nascholing',
    // 	component: Nascholing
    // },
    // {
    // 	path: '/scholing/scholing-talentenspel-coaches',
    // 	component: ScholingTalentenspelCoaches
    // },
    // {
    // 	path: '/contact',
    // 	component: Contact
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js